/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { forwardRef } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import {
    string, func, bool, instanceOf,
} from 'prop-types';
import inputStyles from './addressorzipinput.module.css';

const AddressOrZipInput = forwardRef((props, innerRef) =>  {
    const {
        id, dataTest, label, name, type, value, handleChange, handleFocus, handleBlur, handleKeyDown, handleClick, onSubmitCheck,
    } = props;
    useStyles(inputStyles);
    return (
        <>
            <div className={`${inputStyles.inputContainer} ${onSubmitCheck && inputStyles.inputErrorBorder}`}>
                <input
                    id={id}
                    data-test={dataTest}
                    name={name}
                    className={inputStyles.input}
                    type={type}
                    inputRef={innerRef}
                    value={value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    onKeyDown={handleKeyDown}
                    onClick={handleClick}
                    required
                    pattern=".*\S.*"
                // {...inputProps}
                />
                {/* DO NOT MOVE PLACEMENT OF LABEL IT WILL BREAK CSS ANIMATION/PLACEMENT OF LABEL */}
                <label className={inputStyles.label} htmlFor={id}>{label}</label>
            </div>
        </>
    );
});

AddressOrZipInput.propTypes = {
    id: string.isRequired,
    dataTest: string.isRequired,
    label: string.isRequired,
    name: string.isRequired,
    type: string.isRequired,
    // defaultValue: string,
    value: string,
    handleChange: func,
    handleFocus: func,
    handleBlur: func,
    handleKeyDown: func,
    handleClick: func,
    onSubmitCheck: bool,
};

AddressOrZipInput.defaultProps = {
    // defaultValue: '',
    value: '',
    handleChange: () => { },
    handleFocus: () => { },
    handleBlur: () => { },
    handleKeyDown: () => { },
    handleClick: () => { },
    onSubmitCheck: false,
};

export default AddressOrZipInput;
